import api from 'lib/apiClient';

export const createForm = (data) => api.post('API/1_0/form.php', data);

export const getForms = (query) =>
  api.get('API/1_0/form.php', { params: query });

export const updateForm = (data) => api.post('API/1_0/form.php', data);

export const deleteForm = (hash) =>
  api.delete('API/1_0/form.php', { params: { hash } });

export const createTheme = (data) => api.post('API/1_0/theme.php', data);

export const getThemes = (query) =>
  api.get('API/1_0/theme.php', { params: query });

export const updateTheme = (data) => api.post('API/1_0/theme.php', data);

export const saveResponse = (data) => {
  return api.post('API/1_0/formResponse.php', data);
};
